module.exports = {"server":"https://sispro.fdi.gob.bo/ws/","serverAuth":"https://sispro.fdi.gob.bo/ws/","timeSessionExpired":30,"debug":false,"onbeforeunload":false,"port":3100,"subDomain":"/","portDev":8880}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 210
// module chunks = 0